import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    DEFAULT: '',
    ERROR: 'Submit/VERIFY_AUTHENTICATOR_CODE_ERROR',
    PENDING: 'Submit/VERIFY_AUTHENTICATOR_CODE_PENDING',
    SUCCESS: 'Submit/VERIFY_AUTHENTICATOR_CODE_SUCCESS'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
